import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_43ezgtu33e: FaireBrandEntity = {
  token: "b_43ezgtu33e",
  type: "brand",
  name: "Cleaner Cloths",
  avatarUrl:
    "https://cdn.faire.com/fastly/3501fa8408bfedead2da9b05f27769d38d134c3780e7d960bb069e34fe4eafc9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/029f5fe3ca5204d3a73084bf481b435684979ada8d0a22e5092771088fe19522.png",
  logoUrl:
    "https://cdn.faire.com/fastly/3501fa8408bfedead2da9b05f27769d38d134c3780e7d960bb069e34fe4eafc9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/029f5fe3ca5204d3a73084bf481b435684979ada8d0a22e5092771088fe19522.png",
  location: "Eugene, OR, USA",
  minimumOrderDollars: 75,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "We are a family business that aims to make Sweden's sustainable dishcloths affordable to all. Cleaner Cloths are manufactured by the Swedish company that invented the material, so you can rest assured knowing you will receive the highest quality cloths, at the most affordable prices. We work with retailers to offer cloths in bulk, at affordable pricing, and with low minimums. All orders are shipped with as minimal packaging as possible. Thank you!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:22.521Z",
    importedBy: "entity-db-cli",
  },
};
